import { Box, styled } from "@mui/material";

export const StyledQuotesPage = styled(Box)(({ theme }) => ({
  width: "100%",
  ".header": {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingInline: "1rem",
    ".buttonWrapper": {
      display: "flex",
      gap: "1rem",

      button: {
        display: "flex",
        gap: "1rem",
        "&:hover": {
          borderColor: theme.color.dark,
          background: theme.color.background,
          color: theme.color.dark,
        },
      },
      ".createBtn": {
        background: theme.color.main,
        color: theme.color.background,
        "&:hover": {
          background: theme.color.dark,
          color: theme.color.background,
        },
      },
    },
  },
}));
